import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PixHelpComponent } from '../../help/help.component';
import { PixLimitsReturn, PixLimitsReturnTipo } from '../../models/limits-return.model';
import { PixLimitsService } from '../limits.service';

@Component({
	selector: 'app-adjust',
	templateUrl: './adjust.component.html',
	styleUrls: ['./adjust.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixAdjustComponent implements OnInit {

	public title = 'Pix';
	public subtitle = '';
	public form: FormGroup;
	public submitted = false;
	public selectedLimit: PixLimitsReturn;

	constructor(
		private router: Router,
		private formBuilder: FormBuilder,
		private pixLimitsService: PixLimitsService,
		public dialog: MatDialog,
	) {
	}

	ngOnInit(): void {
		this.selectedLimit = this.pixLimitsService.getSelectedLimit();

		if (this.invalidParams()) {
			this.goBack();
		} else {
			this.buildForm();
		}
	}

	buildForm() {
		this.form = this.formBuilder.group({
			type: [this.selectedLimit.tipo],
			value: [this.selectedLimit.valor, [Validators.required, Validators.min(0.01), Validators.max(this.selectedLimit.valorMaximo)]]
		});

		this.createTitle();
	}

	createTitle() {
		switch (this.selectedLimit.tipo) {
			case PixLimitsReturnTipo.PIX_DIURNO: {
				this.subtitle = 'Para transações diurnas';
				break;
			}
			case PixLimitsReturnTipo.PIX_NOTURNO: {
				this.subtitle = 'Para transações noturnas';
				break;
			}
		}
	}

	showInfo() {
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	public submit() {
		if (this.form.valid) {

			this.selectedLimit.valor = this.form.get('value').value;
			this.pixLimitsService.setSelectedLimit(this.selectedLimit);
			this.router.navigate(['pix/limites/ajustar/assinatura/']);
		}
	}

	public showInfoLimitZero() {
		return this.form.get('value').value === 0;
	}

	public getTextLimitZero(): string {
		const pixType = this.subtitle.charAt(0).toLowerCase() + this.subtitle.substr(1);
		return 'Atenção!<br> Ao definir o limite zerado, você ficará impossibilitado de realizar transações Pix ' + pixType;
	}

	public verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	private invalidParams(): boolean {
		return this.selectedLimit === undefined || this.selectedLimit.valor === undefined || this.selectedLimit.tipo === undefined;
	}

	public goBack = () => this.router.navigate(['pix/limites/']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/limits/adjust/adjust.component.ts